import { environment } from '../../environments/environment';

export const PRE_URL = environment.occBaseUrl + environment.occPrefix + environment.occBaseSite;